import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoriesOverview } from '../../../store/Slices/CategorySlice';
import Stats from '../../../components/Stats';
import { activeStatsIcon, lateStatsIcon, tripStatsIcon } from '../../../utils/svgs';

const CategoryOverviewCards = () => {
    const dispatch = useDispatch();
    const { categoriesOverview, categoriesOverviewLoading } = useSelector((state) => state.categories);

    useEffect(() => {
        dispatch(getCategoriesOverview());
    }, [dispatch]);

    const statsData = [
        {
            title: 'Total Categories',
            value: categoriesOverview?.total || 0,
            text: 'Total number of categories',
            icon: tripStatsIcon,
            className: 'total' // Default blue border
        },
        {
            title: 'Active',
            value: categoriesOverview?.active || 0,
            text: 'Active maintenance categories',
            icon: activeStatsIcon,
            className: 'completed' // Green border from CSS
        },
        {
            title: 'Inactive',
            value: categoriesOverview?.inactive || 0,
            text: 'Inactive maintenance categories',
            icon: lateStatsIcon,
            className: 'late' // Red border from CSS
        }
    ];

    if (categoriesOverviewLoading && !categoriesOverview) {
        return (
            <div className="stats_main_div skeleton-loader" style={{ height: '100px', marginBottom: '20px' }}>
                {/* Skeleton state */}
            </div>
        );
    }

    return (
        <Stats statsData={statsData} numberOfColumn={4} />
    );
};

export default CategoryOverviewCards;
